import usePageMeta from "utils/usePageMeta";
/* eslint-disable no-unused-vars */

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import Residential_Section1 from "./sections/Residential_Section1";
import Residential_Section2 from "./sections/Residential_Section2";
import Residential_Section3 from "./sections/Residential_Section3";
import Residential_Section6 from "./sections/Residential_Section6";
import Residential_Section4 from "./sections/Residential_Section4";
import Residential_Section5 from "./sections/Residential_Section5";

function ResidentialCleaning() {
  usePageMeta({
    title: "Residential Cleaning Services Ireland | Spechs",
    description:
      "Professional residential cleaning services across Ireland. Trusted, reliable home cleaners.",
    canonical: "https://www.spechs.ie/cleaning/residential/",
  });
  return (
    <SubPageLayout title="Residential Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Residential_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Residential_Section2 />
      </MKBox>
      {/* <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Residential_Section3 />
      </MKBox> */}
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Residential_Section4 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Residential_Section5 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Residential_Section6 />
      </MKBox>
    </SubPageLayout>
  );
}

export default ResidentialCleaning;
